<h2 mat-dialog-title>
    Rendement de votre projet
</h2>
<div mat-dialog-content>
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    <div class="row">
        <div class="col-md-6 text-center indicateur">
            <label>
                Total :
                <i class="fa fa-question-circle" matTooltip="Prix frais de notaire et travaux inclus"></i>
            </label>
            <b class="value">{{ favorite.price + favorite.notary_price + favorite.works_total  | number:'1.0-0' }} <span class="unit">€</span></b>
        </div>
        <div class="col-md-3 text-center indicateur">
            <label>Rendement brut : </label>
            <b class="value">{{ favorite.efficiency_brut  | number:'1.0-1' }} <span class="unit">%</span></b>
        </div>
        <div class="col-md-3 text-center indicateur">
            <label>Rendement net : </label>
            <b class="value">{{ favorite.efficiency_net  | number:'1.0-1' }} <span class="unit">%</span></b>
        </div>
    </div>
    <div class="row">
        <h4 class="col-md-12">Ajuster les différents curseurs pour effectuer votre simulation :</h4>
        <div class="col-md-6">
            <label>Prix :&nbsp;</label>
            <b class="value">{{ favorite.price  | number:'1.0-0' }} <span class="unit">€</span>
                <span [hidden]="favorite.price == backupFavorite.price"
                      [ngClass]="{'text-green': favorite.price < backupFavorite.price, 'text-red': favorite.price > backupFavorite.price}"> ({{  favorite.price > backupFavorite.price ? '+ ' : '' }}{{ (favorite.price - backupFavorite.price) / backupFavorite.price * 100 | number:'1.0-1' }}
                    %)</span><br/>
            </b>
            <mat-slider
                [max]="backupFavorite.price == 0 ? 1000000 : backupFavorite.price * 1.5"
                [min]="backupFavorite.price * 0.3"
                [step]="500"
                [thumbLabel]=true
                (change)="edit($event, 'price')"
                (input)="favorite.price = $event.value;edit($event, 'price')"
                [displayWith]="commonService.euroLabel"
                [(ngModel)]="favorite.price">
            </mat-slider>
        </div>
        <div class="col-md-6">
            <label>Rendement brut :&nbsp;</label>
            <b class="value">{{ favorite.efficiency_brut  | number:'1.0-1' }} <span class="unit">%</span></b>
            <mat-slider
                [max]="25"
                [min]="1"
                [step]="0.1"
                [thumbLabel]=true
                (change)="updateEfficiency($event)"
                (input)="favorite.efficiency_brut = $event.value;updateEfficiency($event)"
                [displayWith]="commonService.percentLabel"
                [(ngModel)]="favorite.efficiency_brut">
            </mat-slider>
        </div>

        <div class="col-md-6"></div>
        <div class="col-md-6">
            <label>Rendement Net : </label>
            <b class="value">{{ favorite.efficiency_net  | number:'1.0-1' }} <span class="unit">%</span></b>
            <mat-slider
                [max]="25"
                [min]="1"
                [step]="0.1"
                [thumbLabel]=true
                (change)="updateEfficiencyNet($event)"
                (input)="favorite.efficiency_net = $event.value;updateEfficiencyNet($event)"
                [displayWith]="commonService.percentLabel"
                [(ngModel)]="favorite.efficiency_net">
            </mat-slider>
        </div>

        <div class="col-md-6" [hidden]="favorite.lots.length <= 1">
            <br/>
            <label>Total Loyer :&nbsp;</label>
            <b class="value">{{ favorite.amount_rent  | number:'1.0-0' }} <span class="unit">€</span></b>
            <br/>
            <br/>
        </div>

        <div class="col-md-6" [hidden]="favorite.lots.length > 1">
            <label>Loyer :&nbsp;</label>
            <b class="value">{{ favorite.amount_rent  | number:'1.0-0' }} <span class="unit">€</span></b>
            <mat-slider
                [max]="backupFavorite.price == 0 ? 10000 : backupFavorite.price / 50"
                [min]="0"
                [step]="10"
                [thumbLabel]=true
                (change)="edit($event)"
                (input)="favorite.amount_rent = $event.value;edit($event)"
                [displayWith]="commonService.euroLabel"
                [disabled]=""
                [(ngModel)]="favorite.amount_rent">
            </mat-slider>
        </div>

        <div class="col-md-6" [hidden]="favorite.lots.length <= 1">
            <br/>
            <label>Total travaux :&nbsp;</label>
            <b class="value">{{ favorite.works_total  | number:'1.0-0' }} <span class="unit">€</span></b>
            <br/>
            <br/>
        </div>

        <div class="col-md-6" [hidden]="favorite.lots.length > 1">
            <label>Travaux :&nbsp;</label>
            <b class="value">{{ favorite.works_total  | number:'1.0-0' }} <span class="unit">€</span></b>
            <mat-slider
                [max]="backupFavorite.price == 0 ? 1000000 : backupFavorite.price * 2"
                [min]="0"
                [step]="250"
                [thumbLabel]=true
                (change)="edit($event, 'works_total')"
                (input)="favorite.works_total = $event.value;edit($event, 'works_total')"
                [displayWith]="commonService.euroLabel"
                [(ngModel)]="favorite.works_total">
            </mat-slider>
        </div>
        <div [hidden]="favorite.lots.length <= 1" *ngFor="let lot of favorite.lots; index as i;" class="col-md-12{{ i % 2 == 0 ? ' bg-light' : ''}}">
            <div class="row">
                <h4 class="col-md-12">{{ lot.title }}</h4>
                <div class="col-md-6">
                    <label>Loyer :&nbsp;</label>
                    <b class="value">{{ lot.amount_rent  | number:'1.0-0' }} <span class="unit">€</span></b>
                    <mat-slider
                        [max]="(lot.amount_rent == 0 ? backupFavorite.price/ favorite.lots.length / 50 : backupFavorite.amount_rent * 2)"
                        [min]="0"
                        [step]="10"
                        [thumbLabel]=true
                        (change)="edit($event)"
                        (input)="lot.amount_rent = $event.value;edit($event)"
                        [displayWith]="commonService.euroLabel"
                        [(ngModel)]="lot.amount_rent">
                    </mat-slider>
                </div>
                <div class="col-md-6">
                    <label>Travaux :&nbsp;</label>
                    <b class="value">{{ lot.works_total  | number:'1.0-0' }} <span class="unit">€</span></b>
                    <mat-slider
                        [max]="backupFavorite.price / favorite.lots.length * 2"
                        [min]="0"
                        [step]="250"
                        [thumbLabel]=true
                        (change)="editLot($event, i, 'works_total')"
                        (input)="lot.works_total = $event.value;edit($event);editLot($event, i, 'works_total')"
                        [displayWith]="commonService.euroLabel"
                        [(ngModel)]="lot.works_total">
                    </mat-slider>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-light btn-sm">
        <i class="fa fa-arrow-left" aria-hidden="true"></i> Annuler
    </button>
    <button type="button" (click)="onYesClick()" class="btn btn-primary btn-sm float-right">
        <i class="fa fa-check" aria-hidden="true"></i> Valider
    </button>
</div>
